(function(){
  'use strict';
  const roles=['gift','video','rush'];
  const demo={base:3990,gift:0,video:2990,rush:0,compare:7990};
  function selections(raw){return {gift:raw?.gift===true&&raw?.giftChoiceVersion===1,giftChoiceVersion:raw?.giftChoiceVersion===1?1:0,video:false,rush:raw?.rush===true,redos:raw?.redos!==false};}
  function includedAddons(config,design){
    const free=k=>config.enabled?.[k]===true&&(design||!!(config.addons?.[k]?.id&&config.addons[k].available===true&&config.addons[k].price===0));
    return {gift:free('gift'),giftChoiceVersion:1,video:false,rush:free('rush'),redos:true,includedVersion:1};
  }
  function owned(item,briefId){const p=item.properties||{};return p._sb_paid_presale==='1'&&p._sb_brief_id===briefId;}
  function sameProps(a,b){const ak=Object.keys(a||{}).sort(),bk=Object.keys(b||{}).sort();return JSON.stringify(ak)===JSON.stringify(bk)&&ak.every(k=>String(a[k])===String(b[k]));}
  async function reconcileCart({items,briefId,request,currency,errorMessage,requireFreeAddons=false}){
    const fail=()=>new Error(errorMessage||'Checkout is temporarily unavailable. Please try again.');
    if(typeof request!=='function'||typeof briefId!=='string'||!/^[A-Za-z0-9_-]{8,64}$/.test(briefId)||!Array.isArray(items)||!items.length)throw fail();
    const wanted=items.map(item=>({...item,properties:{...item.properties}})),seen=new Set();
    for(const item of wanted){
      const role=item.properties._sb_presale_role;
      if(!owned(item,briefId)||item.quantity!==1||!/^\d+$/.test(String(item.id))||Number(item.id)<=0||!['song','gift','rush'].includes(role)||seen.has(role))throw fail();
      seen.add(role);
    }
    if(!seen.has('song'))throw fail();
    for(let attempt=0;attempt<60;attempt++){
      const cart=await request('cart.js');
      if(!Array.isArray(cart.items)||(currency&&cart.currency&&cart.currency!==currency))throw fail();
      const managed=cart.items.filter(item=>owned(item,briefId));
      const obsolete=managed.find(existing=>!wanted.some(item=>item.properties._sb_presale_role===existing.properties._sb_presale_role&&String(item.id)===String(existing.variant_id)));
      if(obsolete){await request('cart/change.js',{id:obsolete.key,quantity:0});continue;}
      let changed=false;
      for(const item of wanted){
        const matches=managed.filter(existing=>existing.properties._sb_presale_role===item.properties._sb_presale_role&&String(existing.variant_id)===String(item.id));
        if(matches.length>1){
          const keep=matches.find(existing=>existing.quantity===1&&sameProps(existing.properties,item.properties))||matches[0];
          await request('cart/change.js',{id:matches.find(existing=>existing!==keep).key,quantity:0});changed=true;break;
        }
        if(matches.length===1&&(matches[0].quantity!==1||!sameProps(matches[0].properties,item.properties))){
          await request('cart/change.js',{id:matches[0].key,quantity:1,properties:item.properties});changed=true;break;
        }
      }
      if(changed)continue;
      const missing=wanted.filter(item=>!managed.some(existing=>existing.properties._sb_presale_role===item.properties._sb_presale_role&&String(existing.variant_id)===String(item.id)));
      if(missing.length){await request('cart/add.js',{items:missing});continue;}
      if(requireFreeAddons){
        const charged=managed.find(item=>['gift','rush'].includes(item.properties._sb_presale_role)&&Number(item.original_price??item.price)!==0);
        if(charged){await request('cart/change.js',{id:charged.key,quantity:0});throw fail();}
      }
      return cart;
    }
    throw fail();
  }
  async function resumeCheckoutDraft({state,request,newBriefId,persist}){
    if(!state.checkoutAt)return;
    const {briefId,checkoutAt}=state;
    const cart=await request('cart.js');
    if(!cart||!Array.isArray(cart.items))throw new Error('Cart unavailable');
    if(state.briefId!==briefId||state.checkoutAt!==checkoutAt)return;
    if(cart.items.some(item=>item&&item.properties&&item.properties._sb_brief_id===briefId))return;
    state.briefId=newBriefId();state.checkoutAt='';persist();
  }
  function create(root,api){
    const configElement=root.querySelector('[data-presale-config]');
    if(!configElement)return null;
    const config=JSON.parse(configElement.textContent),copy=JSON.parse(root.querySelector('[data-presale-copy]').textContent);
    const design=config.designOnly!==false;
    const prices=()=>design?demo:Object.assign({base:config.base.price,compare:config.base.compare},Object.fromEntries(roles.map(k=>[k,config.addons[k].price])));
    const currency=()=>design?'USD':config.currency;
    const money=c=>new Intl.NumberFormat(config.locale||'en',{style:'currency',currency:currency(),currencyDisplay:'symbol'}).format(c/100);
    const state=()=>includedAddons(config,design);
    const eligible=k=>state()[k]===true;
    const q=s=>root.querySelector('[data-sbq-screen] '+s);
    let busy=false,otherItems=null;
    const error=message=>{const el=q('[data-presale-error]');if(el){el.textContent=message;el.hidden=!message;if(message)el.scrollIntoView({block:'nearest',behavior:'auto'});}};
    function total(){const selected=state(),p=prices();return p.base+roles.reduce((sum,k)=>sum+(selected[k]&&eligible(k)?p[k]:0),0);}
    function update(){
      if(!q('.sb-presale'))return;
      const selected=state(),p=prices();
      roles.forEach(k=>{
        const row=q('[data-offer="'+k+'"]');if(!row)return;
        row.hidden=!selected[k];
        const was=row.querySelector('[data-addon-compare]');if(!was)return;
        const compare=design?(k==='rush'?1500:0):Number(config.addons[k]?.compare);
        const historical=k==='gift'&&currency()==='USD'&&String(config.addons[k]?.id)==='67587187212539'?2490:0;
        const regular=Number.isFinite(compare)&&compare>0?compare:historical;
        was.hidden=!(selected[k]&&p[k]===0&&regular>0);
        was.textContent=was.hidden?'':money(regular);
      });
      root.querySelectorAll('[data-sbq-screen] [data-price="base"]').forEach(el=>{el.textContent=money(p.base);});
      q('[data-compare]').hidden=!(p.compare>p.base);
      q('[data-compare]').textContent=money(p.compare);
      q('[data-presale-total]').textContent=money(total());if(q('[data-button-total]'))q('[data-button-total]').textContent=money(total());
      const btn=q('[data-a="presale-buy"]');btn.disabled=busy;btn.setAttribute('aria-busy',String(busy));
      if(!btn.dataset.label)btn.dataset.label=btn.innerHTML;
      if(busy)btn.textContent=copy.opening;else if(btn.innerHTML!==btn.dataset.label)btn.innerHTML=btn.dataset.label;
      q('[data-design-note]').hidden=!design;
      const note=q('[data-other-cart]');note.hidden=!otherItems;
      note.querySelector('[data-other-cart-message]').textContent=otherItems?(otherItems===1?copy.other:copy.others).replace('__COUNT__',otherItems):'';
    }
    function mount(){
      if(!q('.sb-presale'))return;
      const s=api.getState(),props=api.getBrief();
      if(JSON.stringify(s.addons)!==JSON.stringify(state())){s.addons=state();api.persist();}
      root.querySelectorAll('[data-recipient-name]').forEach(el=>el.textContent=props['Recipient Name']);
      for(const [selector,value] of [['[data-order-person]',props['Recipient Name']],['[data-order-occasion]',props.Occasion],['[data-order-genre]',props.Genre]]){q(selector).textContent=value;q(selector).title=value;}
      q('[data-order-person]').title=props['Recipient Name']+(props.Relationship?' ('+props.Relationship+')':'');
      update();
      if(!design)request('cart.js').then(cart=>{otherItems=cart.items.filter(i=>!owned(i,api.getState().briefId)).reduce((n,i)=>n+i.quantity,0);update();}).catch(()=>{});
    }
    function endpoint(path){return (config.root||'/').replace(/\/?$/,'/')+path;}
    async function request(path,body){
      const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),20000);
      try{
        const response=await fetch(endpoint(path),{method:body?'POST':'GET',credentials:'same-origin',...(path==='cart.js'?{cache:'no-store'}:{}),headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:controller.signal});
        if(!response.ok)throw new Error(copy.checkout_error);
        return await response.json();
      }finally{clearTimeout(timeout);}
    }
    function desired(){
      const s=api.getState(),chosen=state(),briefId=s.briefId;
      const properties=Object.assign({},api.getBrief(),{_sb_paid_presale:'1',_sb_brief_id:briefId,_sb_presale_role:'song',_sb_delivery_email:s.email.trim()});
      if(config.sourceProduct)properties._sb_source_product=config.sourceProduct;
      if(chosen.gift)properties['Gift Package']='Added';
      if(chosen.redos)properties['Unlimited Song Redos']='Included';
      return [{id:config.base.id,quantity:1,properties}].concat(roles.filter(k=>chosen[k]&&eligible(k)).map(k=>({id:config.addons[k].id,quantity:1,properties:{_sb_paid_presale:'1',_sb_brief_id:briefId,_sb_presale_role:k,_sb_song_addon:'1',For:api.getBrief()['Recipient Name']}})));
    }
    async function freshPrices(){
      const before=state();
      const targets=[['base',config.base],...roles.filter(k=>k!=='video'&&config.enabled[k]===true&&config.addons[k]?.id&&config.addons[k]?.handle).map(k=>[k,config.addons[k]])];
      let changed=false;
      await Promise.all(targets.map(async([k,item])=>{
        const product=await request('products/'+encodeURIComponent(item.handle)+'.js');
        const variant=product.variants.find(v=>String(v.id)===String(item.id));
        if(!variant||!variant.available){item.available=false;if(k==='base'||before[k])changed=true;return;}
        if(k==='base'&&variant.price!==item.price)changed=true;
        item.available=true;item.price=variant.price;item.compare=variant.compare_at_price||0;
      }));
      if(roles.some(k=>before[k]!==state()[k]))changed=true;
      api.getState().addons=state();api.persist();update();
      if(changed)throw new Error(config.base.available?copy.changed:copy.unavailable);
    }
    async function checkout(){
      if(busy)return;
      error('');
      if(design){error(copy.design_checkout);return;}
      if(!config.base.available){error(copy.unavailable);return;}
      busy=true;update();
      try{
        if(api.ensureBriefId&&!(await api.ensureBriefId()))throw new Error(copy.checkout_error);
        await freshPrices();
        const work=()=>reconcileCart({items:desired(),briefId:api.getState().briefId,request,currency:config.currency,errorMessage:copy.checkout_error,requireFreeAddons:true});
        if(navigator.locks)await navigator.locks.request('songbond-paid-presale-cart',work);else await work();
        const url=new URL(endpoint('checkout'),location.origin);url.searchParams.set('checkout[email]',api.getState().email.trim());
        api.getState().checkoutAt=new Date().toISOString();api.persist();
        location.assign(url.href);
      }catch(e){error(e.message===copy.changed||e.message===copy.unavailable?e.message:copy.checkout_error);}
      finally{busy=false;update();}
    }
    return {mount,checkout,update,total,desired,isBusy:()=>busy,resumeDraft:()=>resumeCheckoutDraft({state:api.getState(),request,newBriefId:api.newBriefId,persist:api.persist})};
  }
  window.SB_PRESALE={create,selections,includedAddons,reconcileCart,resumeCheckoutDraft};
})();
